import React from 'react';
import classNames from 'classnames';

interface TextFieldAdornmentProps {
  text: string;
  containerStyles?: string;
  textStyles?: string;
}

const TextFieldAdornment: React.FC<TextFieldAdornmentProps> = ({
  text,
  containerStyles = '',
  textStyles = '',
}) => {
  return (
    <div
      className={classNames(
        'px-2',
        'h-full',
        'flex-grow',
        'flex',
        'flex-row',
        'items-center',
        containerStyles
      )}
    >
      <p
        className={classNames(
          'text-base',
          'font-primary-regular',
          'leading-5',
          textStyles
        )}
      >
        {text}
      </p>
    </div>
  );
};

export default TextFieldAdornment;
